<!-- The span carries the tooltip: a disabled button sends no mouse events.
     text-base! wins over PrimeNG's smaller icon size, so row icons read at 14px. -->
<span
    class="inline-flex"
    [pTooltip]="disabled() ? disabledReason() || 'Not available' : label()"
    tooltipPosition="top"
>
    <app-button
        [icon]="(icon() ?? button().icon) + ' text-base!'"
        [severity]="severity() ?? button().severity"
        [routerLink]="disabled() ? null : routerLink()"
        queryParamsHandling="preserve"
        [disabled]="disabled()"
        [ariaLabel]="label()"
        [testId]="testId() || action() + '-button'"
        (clicked)="clicked.emit($event)"
    />
</span>
